export default __webpack_public_path__ + "static/media/anash.57c6068f.svg";